import type { Nullable } from 'corgi-types';

import type { ArticleCampaignFragment } from 'common/gql/generated/schema';
import { VoucherType } from '../../banner-voucher-v2/components/enums';

export const extractCampaignBadge = (
  campaigns: Nullable<Array<Nullable<ArticleCampaignFragment>>>
) => {
  if (!campaigns) return null;

  const eligibleCampaign = campaigns.find(c => {
    if (!c || !c.campaignBanner) return false;

    const campaignBanner = c.campaignBanner;

    if (!campaignBanner.campaignType) return false;

    if (
      campaignBanner.campaignType.__typename === 'OnlineCoupon' ||
      (campaignBanner.campaignType.__typename === 'Voucher' &&
        campaignBanner.campaignType.type.__typename === VoucherType.Relative)
    ) {
      return true;
    }
  });

  if (!eligibleCampaign || eligibleCampaign.campaignBanner.priceAfterDiscount === null) {
    return null;
  }

  return {
    priceAfterDiscount: eligibleCampaign.campaignBanner.priceAfterDiscount,
    campaignType: eligibleCampaign.campaignBanner.campaignType.__typename,
    campaignKey: eligibleCampaign.key,
    onlyHomeClub: eligibleCampaign.campaignBanner.campaignType.conditions.onlyHomeClub ?? null,
  };
};
